module.exports = __webpack_public_path__ + "static/img/p1.b442a32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p1.png
// module id = XKbT
// module chunks = 1